module.exports = "/images/carnet.svg?9bcd5aafa3e8bcd53b56cda0ff414663";